import React, { useState, useEffect } from "react"
import MetaTags from "react-meta-tags"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  resetGasProjectFlag,
} from "store/actions"
import "./gasProject.scss"

import { Layout, notification } from "antd"
const { Content } = Layout
import ListGasProject from "./ListGasProject"
notification.config({
  duration: 1,
  rtl: true,
})
const Index = props => {
  const { onResetGasProjectFlag, matches_sm } = props
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)
  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }
  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetGasProjectFlag()
  }, [errorMessage, props.success, props.error])


  const [expanded, setExpanded] = useState("")
  const handleChangeExpand = panel => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <div className="page-content">
      <MetaTags>
        <title>پرونده | واحد گاز</title>
      </MetaTags>

     <div className="p-2">لیست پرونده ها</div>
      {contextHolder}
      <ListGasProject
        matches_sm={matches_sm}
        expanded={expanded} 
        handleChangeExpand={handleChangeExpand}
        openNotification={openNotification}
      />
    </div>
  )
}


const mapStateToProps = ({  GasProjects, }) => ({


})

const mapDispatchToProps = dispatch => ({
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
